
export const initialState = {
	countExistingReports: undefined,
	countGhostReports: undefined,
	toggleState: undefined, // valid values: undefined, 'ALL', 'GHOST', 'EXISTING',
	refReportAggs: [] // references list of reports before filters have been applied, used for calculating countGhostReports & countExistingReports
};

export default initialState;
